module.exports = __webpack_public_path__ + "img/comment-dots-plus.fd0c3243.svg";